import React from 'react'
import {Badge, SubHeader} from '../../'
import { amenitiesData, servicesData } from '../../../utils/constants'
import { RemoveRounded } from '@mui/icons-material'

import './services.css'

const Services = () => {
  return (
    <>
        <div id="services" className='services-wrapper'>
            <Badge title="Our Services and Amenities" />
            <SubHeader title="" description="" />
            <div className="services-container">
            <div className="services-gradient-background"></div>
                <div className='services-container-box'>
                    <div className='services-box'>
                        <div className="services-btn-header">Services</div>
                        <p className='services-sub-header'><RemoveRounded /> Shalom Springs of Plano specializes in providing full service, home Care and non- medical services to the residents.</p>
                        {servicesData.map((result, index) => {
                            return(
                                <div key={index} className='services-main-container'>
                                    <p className='services-text-main'>
                                        <span className='services-bullet-wrapper'>
                                            <span className='services-bullet'></span>
                                        </span>
                                        {result.title}
                                    </p>
                                </div>
                            )  
                        })}
                    </div>
                    <div className='amenities-box'>
                        <div className="services-btn-header">Amenities</div>
                        <p className='services-sub-header'><RemoveRounded /> Our care home features.</p>
                        {amenitiesData.map((result, index) => {
                            return(
                                <div key={index} className='services-main-container'>
                                    <p className='services-text-main'>
                                        <span className='services-bullet-wrapper'>
                                            <span className='services-bullet'></span>
                                        </span>
                                        {result.title}
                                    </p>
                                </div>
                            )  
                        })}
                        <div className='pricing-box'>
                            <div className="services-btn-header">Pricing</div>
                            <p className='services-sub-header'><RemoveRounded /> <span className=''>Pricing is favorable and  varies based on individual needs. <a className='services-sub-contact' href='#contact-us'>Contact Us</a> for a personalized assessment to determine pricing.</span></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>
  )
}

export default Services